import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { CoreModule } from '../../../../core/core.module';
import { NotificationCellModule } from '../../../dashboard/components/notification-cell/notification-cell.module';
import { SegmentedNavigationModule } from '../../../dashboard/components/segmented-navigation/segmented-navigation.module';
import { PatientNavbarModule } from '../../../patient/components/navbar/patient-navbar.module';
import { MyTopbarComponent } from './my-topbar.component';

@NgModule({
  declarations: [MyTopbarComponent],
  imports: [
    CommonModule,
    PatientNavbarModule,
    BsDropdownModule,
    NgxBootstrapIconsModule,
    NotificationCellModule,
    SegmentedNavigationModule,
    CoreModule,
  ],
  exports: [MyTopbarComponent],
})
export class MyTopbarModule {}
